import React from 'react';
import '../English.css';
import { useNavigate } from 'react-router-dom';

export default function EnglishSidebar({
  categories,
  selectedCategory,
  setSelectedCategory,
}) {
  const navigate = useNavigate();
  //console.log('categories', categories, selectedCategory, setSelectedCategory);

  return (
    <aside className="english-sidebar-right">
      <div
        className="english-sidebar-header"
        style={{
          paddingBottom: '1rem',
          borderBottom: '1px solid var(--liwaza-outline-variant)',
        }}
      >
        <h2
          style={{
            color: 'var(--liwaza-primary)',
            fontWeight: 600,
            fontSize: '1.25rem',
            margin: 0,
            marginBottom: '0.5rem',
          }}
        >
          IELTS Test Sections
        </h2>
        <p
          className="english-sidebar-subtitle"
          style={{
            color: 'var(--liwaza-secondary)',
            fontSize: '0.875rem',
            margin: 0,
          }}
        >
          Select a section to start practicing
        </p>
      </div>
      <nav className="english-sidebar-nav">
        {categories?.map((cat) =>
          cat.type === 'separator' ? (
            <div key={cat.key} className="english-sidebar-separator" />
          ) : (
            <div
              key={cat.key}
              className={`english-sidebar-item${selectedCategory === cat.key ? ' active' : ''}`}
              onClick={() => {
                if (cat.key === 'progression') {
                  navigate('/exams/english/progression');
                } else if (cat.key === 'journey') {
                  navigate('/exams/english/journey');
                } else {
                  navigate('/exams/english/', {
                    state: {
                      activeCategory: cat.key,
                    },
                  });
                }
              }}
            >
              <span style={{ display: 'flex', alignItems: 'center' }}>
                {cat.icon}
              </span>
              <span style={{ fontSize: 15 }}>{cat.label}</span>
              {cat.tag && (
                <span
                  className={`english-sidebar-tag${cat.tag === 'New' ? ' new' : ''}`}
                  style={{
                    background: 'var(--liwaza-secondary-container)',
                    color: 'var(--liwaza-on-secondary-container)',
                    marginLeft: 12,
                  }}
                >
                  {cat.tag}
                </span>
              )}
            </div>
          )
        )}
      </nav>
    </aside>
  );
}
